<!-- =========================================================================================
    File Name: StatisticsCard.vue
    Description: Statistics card component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <vx-card >
      <div slot="no-body">
        <div class="vx-card__header">
          <div class="vx-card__title">
            <h4>{{ $t(i18n) || title }}</h4>
          </div>
          <div class="vx-card__actions">
            <div class="vx-card__action-buttons">
              <feather-icon v-if="enableZoomIn" @click="zoomIn" icon="SearchIcon" svgClasses="h-6 w-6" class="ml-4" />
              <feather-icon v-if="enableDrilling" @click="drillTo" icon="CornerRightDownIcon" svgClasses="h-6 w-6" class="ml-4"/>
            </div>
          </div>
        </div>
        <div class="mt-5 ml-6 flex">
          <div class="mr-6">
              <p class="mb-1 font-semibold">{{ $t(leftDataTitlei18n) || leftDataTitle }}</p>
              <p class="text-3xl text-success"><sup class="text-base mr-1">$</sup>{{ formattedLeftData }}</p>
          </div>
          <div>
              <p class="mb-1 font-semibold">{{ $t(rightDataTitlei18n) || rightDataTitle }}</p>
              <p class="text-3xl"><sup class="text-base mr-1">$</sup>{{ formattedRightData }}</p>
          </div>
        </div>
        <div>
            <vue-apex-charts
              type="line"
              height="266"
              :options="chartOptions"
              :series="chartData" />
        </div>
      </div>
    </vx-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import chartConfigs from './chartConfigs.js'
import shared from '@/filters/shared.js'

export default {
  props: {
    title: {
      type: String
    },
    i18n : {
      type: String
    },
    linkTo: {
      type: String
    },
    enableZoomIn: {
      type: Boolean,
      default: false
    },
    leftDataTitle: {
      type: String
    },
    leftDataTitlei18n: {
      type: String
    },
    leftDataValue: {
    },
    dataFilter: {
      type: String
    },
    rightDataTitle: {
      type: String
    },
    rightDataTitlei18n: {
      type: String
    },
    rightDataValue: {
    },
    categories : {

    },
    chartData: {
      // type: Array,
      // required: true
    }
  },
  
  computed : {
    formattedLeftData() {
      return shared.formatValue(this.leftDataValue, this.dataFilter, this);
    },
    formattedRightData() {
      return shared.formatValue(this.rightDataValue, this.dataFilter, this);
    },
    enableDrilling() {
      return this.linkTo !== "" && typeof this.linkTo !== 'undefined';
    }
  },
  data () {
    return {
      chartOptions: null
    }
  },
  components: {
    VueApexCharts
  },
  created () {
    this.chartOptions = Object.assign({}, chartConfigs.comparisonLine)

    if (this.$props.categories) {
      if (this.chartOptions.xaxis) {
        this.chartOptions.xaxis.categories = this.$props.categories
      } else {
        this.chartOptions.xaxis = {
          categories : this.$props.categories
        }
      }
    }
  }
}
</script>
